/* eslint-disable @typescript-eslint/no-explicit-any */

import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {
  IDynamicFormAccordion,
  IDynamicFormAccordionTab,
  IDynamicFormCheckbox,
  IDynamicFormDate,
  IDynamicFormFieldType,
  IDynamicFormInputGroup,
  IDynamicFormInputNumber,
  IDynamicFormInputText,
  IDynamicFormMultiSelect,
  IDynamicFormRadioButton,
  IDynamicFormSelect,
  IDynamicFormTextarea,
  IDynamicFormVariableAccordion,
  IDynamicFormVariableAccordionTab,
} from '../models/dynamic.model';

export class DynamicFormUtils {
  static castAsSelect(formTemplateItem: IDynamicFormFieldType) {
    return formTemplateItem as IDynamicFormSelect;
  }
  static castAsMultiSelect(formTemplateItem: IDynamicFormFieldType) {
    return formTemplateItem as IDynamicFormMultiSelect;
  }
  static castAsDate(formTemplateItem: IDynamicFormFieldType) {
    return formTemplateItem as IDynamicFormDate;
  }
  static castAsCheckbox(formTemplateItem: IDynamicFormFieldType) {
    return formTemplateItem as IDynamicFormCheckbox;
  }
  static castAsRadioButton(formTemplateItem: IDynamicFormFieldType) {
    return formTemplateItem as IDynamicFormRadioButton;
  }
  static castAsTextarea(formTemplateItem: IDynamicFormFieldType) {
    return formTemplateItem as IDynamicFormTextarea;
  }
  static castAsInputGroup(formTemplateItem: IDynamicFormFieldType) {
    return formTemplateItem as IDynamicFormInputGroup;
  }
  static castAsAccordion(formTemplateItem: IDynamicFormFieldType) {
    return formTemplateItem as IDynamicFormAccordion;
  }
  static castAsAccordionTab(formTemplateItem: IDynamicFormFieldType) {
    return formTemplateItem as IDynamicFormAccordionTab;
  }
  static castAsVariableAccordion(formTemplateItem: IDynamicFormFieldType) {
    return formTemplateItem as IDynamicFormVariableAccordion;
  }
  static castAsVariableAccordionTab(formTemplateItem: IDynamicFormFieldType) {
    return formTemplateItem as IDynamicFormVariableAccordionTab;
  }
  static castAsInputNumber(formTemplateItem: IDynamicFormFieldType) {
    return formTemplateItem as IDynamicFormInputNumber;
  }
  static castAsInputText(formTemplateItem: IDynamicFormFieldType) {
    return formTemplateItem as IDynamicFormInputText;
  }

  static cloneFormGroup(original: FormGroup): FormGroup {
    const clonedGroup = new FormGroup({});

    Object.keys(original.controls).forEach(key => {
      const control = original.get(key);

      if (control instanceof FormControl) {
        clonedGroup.addControl(key, new FormControl(null, control.validator ?? null, control.asyncValidator ?? null));
      } else if (control instanceof FormGroup) {
        clonedGroup.addControl(key, this.cloneFormGroup(control));
      } else if (control instanceof FormArray) {
        clonedGroup.addControl(key, this.cloneFormArray(control));
      }
    });

    clonedGroup.reset();
    clonedGroup.setErrors(null);
    clonedGroup.markAsPristine();
    clonedGroup.markAsUntouched();
    clonedGroup.updateValueAndValidity();
    return clonedGroup;
  }

  static cloneFormArray(original: FormArray): FormArray {
    const clonedArray = new FormArray<any>([]);

    original.controls.forEach(control => {
      if (control instanceof FormGroup) {
        clonedArray.push(this.cloneFormGroup(control));
      } else if (control instanceof FormControl) {
        clonedArray.push(new FormControl(null, control.validator ?? null, control.asyncValidator ?? null));
      } else if (control instanceof FormArray) {
        clonedArray.push(this.cloneFormArray(control));
      }
    });

    clonedArray.setErrors(null);
    clonedArray.markAsPristine();
    clonedArray.markAsUntouched();
    clonedArray.updateValueAndValidity();
    return clonedArray;
  }
}
